// This allows to get a unit equivalent to the viewport height on mobile
// when 100vh exceeds the size of the viewport, with fallback support
// for old browsers with no CSS variables support. For this workaround
// to work, full-view-height needs to be set by client-side javascript
// otherwise it has no effect and defaults to 100vh.
const generateFullViewHeight = renderCSS => {
  return `
    ${renderCSS('100vh')}
    ${renderCSS('var(--full-view-height, 100vh)')}
  `;
};
const viewport = {
  height: generateFullViewHeight(vh => `height: ${vh};`),
  minHeight: generateFullViewHeight(vh => `min-height: ${vh};`),
  generate: generateFullViewHeight
};
export { viewport as default };
//# sourceMappingURL=viewport.js.map
